/* istanbul ignore file */
import { Container, Plugins } from '@getgo/container-client'
import { getEventBus } from '../namespaces/event-bus'
import type { I18NEvents } from '../i18n'
import { I18NNamespace } from '../i18n'
import {
  closeAllWindows,
  closeWindow,
  getWindowOptions,
  isMainWindow,
  isShellWindowActive,
  openWindow,
} from './windows-management'
import { Launcher } from '../launcher'
import { onWindowUnload } from '../../common/helpers/window'

export * from './windows-management'

export const containerAPI = {
  isMainWindow: (window: Window) => isMainWindow(window),
  openWindow: openWindow,
  getWindowOptions: getWindowOptions,
  closeWindow: closeWindow,
  closeAllWindows: closeAllWindows,
  isShellWindowActive: isShellWindowActive,
  currentWindow: Plugins.CurrentWindow,
  windowManager: Plugins.WindowManager,
  containerSettings: Plugins.ContainerSettings,
}

export const initContainerEvents = () => {
  if (Container.isPluginAvailable('ContainerSettings')) {
    const { localeChanged } = getEventBus().subscribeTo<typeof I18NNamespace, typeof I18NEvents>(I18NNamespace)

    const setLocaleListener = (locale: string) => {
      Plugins.ContainerSettings.setLocale(locale)
    }

    localeChanged.on(setLocaleListener)

    onWindowUnload(() => {
      localeChanged.removeListener(setLocaleListener)
    })
  }

  handleContainerLaunchCommands()
}

/** Forwards launch commands from the Container to the Shell/Experiences. */
const handleContainerLaunchCommands = () => {
  if (!Container.isPluginAvailable('LifeCycle')) {
    return
  }

  Plugins.LifeCycle.appReady({
    launcher: (request: never) => Launcher.getInstance().appLauncher(request), // TODO: fix types on Jenkins
    quitter: (): void => undefined, // TODO: implement handling of quit requests
  })
}
